import RYBConnectClasses from "../../../common/services/classes.service";
import { trackingService } from "../../../common/services/tracking.service";
import { setFilterTopView } from "../views/filter-top.view";
import {
  setResultGridView,
  setToggleTableFunctionality,
} from "../views/result-grid.view";
import { initSessionToolbar } from "../views/session-toolbar.view";

const config = {
  attributes: true,
  childList: false,
  subtree: false,
  attributeFilter: ["style"],
};
let isProcessing = false;

export function onSetResult() {
  const target = document.querySelector(".result") as Element;
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((_mutation) => {
      if ($(target).is(":visible") && isProcessing === false) {
        processResult();
      }
    });
  });

  if ($(".step.step-result.active")) {
    processResult();
  }

  if (target) {
    observer.observe(target, config);
  }
}

export function processResult() {
  // Skip finder rendering when camps template is active (camps has its own rendering)
  if (document.querySelector("#class-finder.template-camps")) {
    return;
  }

  // Initialize session toolbar (runs once, subsequent calls are no-ops)
  initSessionToolbar(() => processResult());

  const classesManager = new RYBConnectClasses();

  classesManager
    .getFilteredDataByURLParams()
    .then((response) => {
      $(".step-loading").hide();

      if (response.length) {
        if ($(".ryb-nav .step.step-result").hasClass("active")) {
          $(".close-wizard-button.reset").removeClass("d-none");
          $(".ryb-nav .step").addClass("disabled");
          $(".close-wizard-button.back").addClass("d-none");
          $("#ryb-connect .bottom-controls").addClass("d-none");
          $("#ryb-connect").addClass("full-height");
        }
        trackingService.pushEvent("ryb_schedule_viewed", {
          class_count: response.length,
        });
        setFilterTopView();
        setResultGridView(response);
        setToggleTableFunctionality();
      } else {
        // Empty result on initial load — keep filter pills visible so the
        // user can adjust, then defer to setResultGridView() for the
        // fallback render (centralized so dynamic filter changes also
        // trigger it).
        trackingService.pushEvent("ryb_schedule_empty", {});
        setFilterTopView();
        setResultGridView(response);
      }
    })
    .catch((_error: any) => {
      $("#ryb-openings-result").html(
        `<p class="display:block">Error: Unable to fetch class openings.</p>`
      );
    })
    .finally(() => {
      isProcessing = false;
    });
}
